import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { getAgencySmsLog, getAgencySmsLogs } from './api';
import { AgencySmsLogResponse, AgencySmsLogsListResponse } from './types';

type SmsLogsQueryOptions = Omit<UseQueryOptions<AgencySmsLogsListResponse, Error>, 'queryKey' | 'queryFn'>;
type SmsLogQueryOptions = Omit<UseQueryOptions<AgencySmsLogResponse, Error>, 'queryKey' | 'queryFn'>;

export function useGetAgencySmsLogs(params?: Record<string, unknown>, options?: SmsLogsQueryOptions) {
  return useQuery<AgencySmsLogsListResponse>({
    queryKey: ['agency_sms_logs', params],
    queryFn: () => getAgencySmsLogs(params),
    ...options
  });
}

export function useGetAgencySmsLog(
  id: number | string | null | undefined,
  params?: Record<string, unknown>,
  options?: SmsLogQueryOptions
) {
  return useQuery<AgencySmsLogResponse>({
    queryKey: ['agency_sms_log', id, params],
    queryFn: () => getAgencySmsLog(id!, params),
    enabled: Boolean(id),
    ...options
  });
}
